// extracted by mini-css-extract-plugin
export default {"card":"deactivate-account_card__0+d+n","delBtn":"deactivate-account_delBtn__NlGQA"};